const STATUS_COLORS: Record<string, string> = {
  RESOLVED_AUTO: 'var(--accent-good)',
  RESOLVED_HUMAN: 'var(--accent-good)',
  FLAGGED: 'var(--accent-warning)',
  ESCALATED: 'var(--accent-critical)',
  PROCESSING: 'var(--accent-info)',
  DETECTED: 'var(--text-dimmer)',
  QUEUED: 'var(--text-dimmer)',
  PENDING_HUMAN: 'var(--accent-warning)',
};

export default function StatusDot({ status, size = 7 }: { status: string; size?: number }) {
  const color = STATUS_COLORS[status] || 'var(--text-dimmer)';
  return (
    <span style={{
      display: 'inline-block', width: size, height: size, borderRadius: '50%', background: color,
      animation: status === 'PROCESSING' ? 'pulse 2s infinite' : 'none',
    }} />
  );
}
